module.exports = __webpack_public_path__ + "b3ca732e8bda988c8449faa61e141442.png";


//////////////////
// WEBPACK FOOTER
// ./content/help/default/variant-naming/images-more-on-naming/img5.png
// module id = 1308
// module chunks = 0